import { Fade, Typography } from '@material-ui/core'

import NoDataImage from '../../assets/images/No-Data.png'
import { Promotion } from '../../graphql/promotions'
import { getTranslate } from '../../localization'
import PromotionRowSkeleton from './PromotionRow.skeleton'
import PromotionRowMobile from './PromotionRowMobile'
import useStyles from './styles/PromotionsTable.styles'

interface PromotionsTableMobileProps {
  data: Promotion[]
  loading: boolean
  reloadData: () => void
}

export const PromotionsTableMobile: React.FC<PromotionsTableMobileProps> = ({
  data,
  loading,
  reloadData
}) => {
  const classes = useStyles()

  return (
    <div className={classes.root}>
      <div className={classes.tableHeadMobile}>
        <div>
          <Typography variant="body1">{getTranslate('Name')}</Typography>
        </div>
        <div>
          <Typography variant="body1">{getTranslate('Status')}</Typography>
        </div>
        <div>
          <Typography variant="body1">{getTranslate('Discount')}</Typography>
        </div>
        <div />
      </div>
      {loading ? (
        Array(5)
          .fill('')
          .map((item, index) => (
            <PromotionRowSkeleton
              mobile
              key={`promotion-skeleton-mobile${index.toString()}`}
            />
          ))
      ) : data.length > 0 ? (
        data.map((promotion) => (
          <Fade in timeout={600} key={promotion.id}>
            <div data-cy="tableRowPromotionDataMobile">
              <PromotionRowMobile data={promotion} refetch={reloadData} />
            </div>
          </Fade>
        ))
      ) : (
        <div className={classes.noDataImageContainer}>
          <img src={NoDataImage} alt={getTranslate('No promotions')} />
        </div>
      )}
    </div>
  )
}
